// extracted by mini-css-extract-plugin
module.exports = {"root":"Layout_root__ZGYJE","logo":"Layout_logo__9in8L","termsOfUse":"Layout_termsOfUse__Ho6IL","divider":"Layout_divider___f06Q"};